import { Injectable } from '@angular/core';
import { Claims } from 'src/app/_models/common/claims';
import { HttpClient } from '@angular/common/http';
import { ClaimsHeaderService } from 'src/app/shared/claimsHeader/claims-header.service';
import { IApiRequest, IApiresponse, IEmpListByVehicleRequestDto, IEmpListByVehicleResponseDto, NRFCStatusEnum, PaymentTypeEnum } from 'src/app/_models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IOrgVehiclesNRFCRequest } from 'src/app/_models/NrFc/org-vehicles-nrfcrequest';
import { IOrgVehiclesNRFCResponse } from 'src/app/_models/NrFc/org-vehicles-nrfcresponse';
import { ClaimsService } from '../common/claims.service';
import { INRFCApproverClaimantListRequest } from 'src/app/_models/NrFc/nrfcapprover-claimant-list-request';
import { FuelCardDetails, IFCReceiptResponse } from 'src/app/_models/NrFc/fcreceipt-response';
import { IGetNRFCListRequest } from 'src/app/_models/NrFc/get-nrfclist-request';
import { INRReceiptResponse } from 'src/app/_models/NrFc/nrreceipt-response';
import { INRFCUpdateReceiptRequest } from 'src/app/_models/NrFc/nrfcupdate-receipt-request';
import { INRFCUpdateReceiptResponse } from 'src/app/_models/NrFc/nrfcupdate-receipt-response';
import { IGetNRFCListResponse } from 'src/app/_models/NrFc/get-nrfclist-response';
import { IClaimantListForNRFCApproval } from 'src/app/_models/NrFc/claimant-list-for-nrfcapproval';
import { INRGetDashboardClaimaintResponse } from 'src/app/_models/NrFc/nrget-dashboard-claimaint-response';
import { INRDashboardReceiptResponse } from 'src/app/_models/NrFc/nrdashboard-receipt-response';
import { FCReportRequest } from 'src/app/_models/NrFc/fcreport-request';
import { IFCGetReportResponse } from 'src/app/_models/NrFc/fcget-report-response';
import { map } from 'rxjs/operators';
import { INRReceiptGetList } from 'src/app/_models/NrFc/nrreceipt-get-list';
import { DatePipe } from '@angular/common';
import { IFCReceiptGetList } from 'src/app/_models/NrFc/fcreceipt-get-list';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NrFcService {
  orgId: number;
  userId: number;
  token: string;
  loginid: string;
  claims: Claims;
  constructor(private http: HttpClient, private claimsHeaderService: ClaimsHeaderService
    , private claimsService: ClaimsService, public datepipe: DatePipe, private translate: TranslateService) {
    this.claimsService.currentClaims.subscribe(claims => this.claims = claims);
    this.orgId = this.claims.OrgId;
    this.userId = this.claims.UserId;
    this.token = this.claims.Token;
    this.loginid = this.claims.LoginId;
  }

  SoloGetOrgVehicleNRFCDetails(requestinfo: IApiRequest<IOrgVehiclesNRFCRequest>): Observable<IApiresponse<IOrgVehiclesNRFCResponse>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<IOrgVehiclesNRFCResponse>>(`${environment.billingApiUrl}GetOrgVehicleNRFCDetails`, body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloSaveOrgVehicleNRFCDetails(requestinfo: IApiRequest<IOrgVehiclesNRFCResponse>): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<any>>(`${environment.billingApiUrl}SaveOrgVehicleNRFCDetails`, body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloGetOwnershipTypesByNRFC(requestinfo: IApiRequest<IOrgVehiclesNRFCRequest>): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<any>>(`${environment.billingApiUrl}GetOwnershipTypesByNRFC`, body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SoloGetNRFCAssignedOrgVehicles(request: IApiRequest<IEmpListByVehicleRequestDto>): Observable<IApiresponse<IEmpListByVehicleResponseDto>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<IEmpListByVehicleResponseDto>>(`${environment.billingApiUrl}GetNRFCAssignedOrgVehicles`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SoloNRFCGetClaimantListForApproval(request: IApiRequest<INRFCApproverClaimantListRequest>): Observable<IApiresponse<IClaimantListForNRFCApproval>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<IClaimantListForNRFCApproval>>(`${environment.expenseApiUrl}NRFCGetClaimantListForApproval`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  SoloNRFCGetReceiptList(request: IApiRequest<IGetNRFCListRequest>): Observable<IGetNRFCListResponse> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<IGetNRFCListResponse>>(`${environment.expenseApiUrl}NRFCGetReceiptList`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => {
        if (request.requestInfo.nrfcStatus == NRFCStatusEnum.NR) {
          return this.mapNRList(result);
        }
        else {
          return this.mapFCList(result);
        }


      }
      ));
  }
  mapNRList(result): IGetNRFCListResponse {
    let response: IGetNRFCListResponse = null;
    if (result && result.responseInfo) {
      response = {
        countOfRec: result.responseInfo.countOfRec,
        nrReceiptGetList: result.responseInfo.nrReceiptGetList.map(e => {
          if (e != null && e != undefined) {
            return this.mapNR(e);
          }
        }
        ),
        fcReceiptGetList: null,
        hasMorePage: result.responseInfo.hasMorePage,
        totalExpenseCount: 0,
        userId: 0
      };
    }
    return response;
  }
  mapFCList(result): IGetNRFCListResponse {
    let response: IGetNRFCListResponse = null;
    if (result && result.responseInfo) {
      response = {
        countOfRec: result.responseInfo.countOfRec,
        nrReceiptGetList: null,
        fcReceiptGetList: result.responseInfo.fcReceiptGetList.map(e => {
          if (e != null && e != undefined) {
            return this.mapFC(e);
          }
        }),
        hasMorePage: result.responseInfo.hasMorePage,
        totalExpenseCount: 0,
        userId: 0
      };
    }
    return response;
  }
  mapNR(e): INRReceiptGetList {
    if (e != null && e != undefined) {
      return {
        amount: e.amount.toFixed(2),
        notes: e.notes,
        nrCurrentStatus: e.nrCurrentStatus,
        nrReceiptId: e.nrReceiptId,
        receiptId: e.nrReceiptId,
        paymentTypeId: e.paymentTypeId,
        receiptDate: e.receiptDate,
        paymentType: e.paymentTypeId == PaymentTypeEnum.CorporateCreditCard ? this.translate.instant("corporate_credit_card") : this.translate.instant("payment_type_cash"),
        receiptDateString: this.datepipe.transform(e.receiptDate, 'dd-MMM-yyyy'),
        selected: false,
        spentCurrencyID: e.spentCurrencyID,
        submissionDate: e.submissionDate,
        supplier: e.supplier,
        hasReceipt: e.hasReceipt,
        spentCurrencyCode: e.spentCurrencyCode,
        exchangeRate: e.exchangeRate,
        exchangeRateUpdatedDate: e.exchangeRateUpdatedDate,
        amountWithTooltips: {}
      };
    }

  }
  mapFC(e): IFCReceiptGetList {
    if (e != null && e != undefined) {
      return {
        businessDistance: e.businessDistance.toFixed(2),
        distanceAvailable: e.distanceAvailable.toFixed(2),
        fcCurrentStatus: e.fcCurrentStatus,
        fcReceiptId: e.fcReceiptId,
        receiptId: e.fcReceiptId,
        hasReceipt: e.hasReceipt,
        notes: e.notes,
        privateDistance: e.privateDistance.toFixed(2),
        receiptDate: e.receiptDate,
        receiptDateString: this.datepipe.transform(e.receiptDate, 'dd-MMM-yyyy'),
        selected: false,
        submissionDate: e.submissionDate,
        vehicleId: e.vehicleId,
        openingBalance: e.openingBalance,
        closingBalance: e.closingBalance,
        openingBalanceDate: e.openingBalanceDate,
        month: this.datepipe.transform(e.openingBalanceDate, 'MMM-yyyy')
      };
    }
  }
  FCGetClaimantReceiptDetail(fcReceiptId): Observable<IFCReceiptResponse> {
    let url = `${environment.expenseApiUrl}FCGetClaimantReceiptDetail/` + fcReceiptId + ``;
    return this.http.get<IApiresponse<IFCReceiptResponse>>(url,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => {
        return this.mapFCDetail(result.responseInfo);
      }
      ));
  }
  mapFCDetail(e): IFCReceiptResponse {
    if (e != null && e != undefined) {
      return {
        businessDistance: e.businessDistance.toFixed(2),
        distanceAvailable: e.distanceAvailable.toFixed(2),
        fcCurrentStatus: e.fcCurrentStatus,
        fcReceiptId: e.fcReceiptId,
        receiptId: e.fcReceiptId,
        hasReceipt: e.hasReceipt,
        notes: e.notes,
        privateDistance: e.privateDistance.toFixed(2),
        receiptDate: e.receiptDate,
        receiptDateString: this.datepipe.transform(e.receiptDate, 'dd-MMM-yyyy'),
        submissionDate: e.submissionDate,
        vehicleId: e.vehicleId,
        closingBalance: e.closingBalance.toFixed(2),
        closingBalanceDate: e.closingBalanceDate,
        closingBalanceDateString: this.fnConvertDate(e.closingBalanceDate),
        distanceTravelled: e.distanceTravelled.toFixed(2),
        nrfcJustificationNotesViewModel: e.nrfcJustificationNotesViewModel,
        nrfcReceiptInfo: e.nrfcReceiptInfo,
        openingBalance: e.openingBalance.toFixed(2),
        openingBalanceDate: e.openingBalanceDate,
        openingBalanceDateString: this.datepipe.transform(e.openingBalanceDate, 'dd-MMM-yyyy'),
        orgId: e.orgId,
        userId: e.userId
      };
    }
  }
  fnConvertDate(closingBalanceDate) {
    let newDate = new Date(closingBalanceDate);
    let newDateUtc = new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate(), 0, 0, 0, 0)).toUTCString();
    let finalDate = this.datepipe.transform(newDateUtc, 'dd-MMM-yyyy');
    return finalDate;
  }
  SoloNRGetReceiptDetailForFM(nrReceiptId): Observable<IApiresponse<INRReceiptResponse>> {
    let url = `${environment.expenseApiUrl}NRGetReceiptDetailForFM/` + nrReceiptId + ``;
    return this.http.get<IApiresponse<INRReceiptResponse>>(url, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SoloNRFCUpdateApprovalStatus(request: IApiRequest<INRFCUpdateReceiptRequest>): Observable<IApiresponse<INRFCUpdateReceiptResponse>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<INRFCUpdateReceiptResponse>>(`${environment.expenseApiUrl}NRFCUpdateApprovalStatus`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SoloNRGetDashboardClaimaintList(request: IApiRequest<IGetNRFCListRequest>): Observable<IApiresponse<INRGetDashboardClaimaintResponse>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<INRGetDashboardClaimaintResponse>>(`${environment.expenseApiUrl}NRGetDashboardClaimaintList`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  SoloNRDashboardClaimaintReceiptList(request: IApiRequest<IGetNRFCListRequest>): Observable<IApiresponse<INRDashboardReceiptResponse>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<INRDashboardReceiptResponse>>(`${environment.expenseApiUrl}NRDashboardClaimaintReceiptList`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  // SoloNRFCGetClaimantReceiptListCount(request: IApiRequest<IGetNRFCListRequest>): Observable<IApiresponse<IGetNRFCListResponse>> {
  //   let body = JSON.stringify(request);
  //   return this.http.post<IApiresponse<IGetNRFCListResponse>>(`${environment.expenseApiUrl}NRFCGetClaimantReceiptListCount`,
  //     body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  // }

  GetFCReceiptToExport(request: IApiRequest<FCReportRequest>): Observable<IApiresponse<IFCGetReportResponse>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<IFCGetReportResponse>>(`${environment.expenseApiUrl}GetFCReceiptToExport`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  GetFCReceiptDetailsByVehicleId(request: IApiRequest<FCReportRequest>): Observable<IApiresponse<IFCGetReportResponse>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<IFCGetReportResponse>>(`${environment.expenseApiUrl}GetFCReceiptDetailsByVehicleId`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  ExportFCReceipt(request: IApiRequest<FCReportRequest>): Observable<IApiresponse<string>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<string>>(`${environment.expenseApiUrl}ExportFCReceipt`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }
  fnUpdateCount(countOfRec, pageType, nrfcStatus) {
    switch (pageType) {
      case 'approver':
        if (nrfcStatus == NRFCStatusEnum.NR) {
          this.claims.pendingCountNRApprover = countOfRec;
        }
        else {
          this.claims.pendingCountFCApprover = countOfRec;
        }
        this.claimsService.updateClaims(this.claims);
        break;
      case 'finance':
        if (nrfcStatus == NRFCStatusEnum.NR) {
          this.claims.pendingCountNRFinanceApproval = countOfRec;
        }
        else {
          this.claims.pendingCountFCFinanceApproval = countOfRec;
        }
        this.claimsService.updateClaims(this.claims);
        break;
    }
  }

  GetFCDashboardForClaimant(selectedMonth): Observable<any> {
    let url = `${environment.expenseApiUrl}GetFCDashboardForClaimant/` + selectedMonth + ``;
    return this.http.get<IApiresponse<any>>(url,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => {
        result.responseInfo.forEach(element => {
          element = this.mapFCGrid(element);
        });
        return result;
      }
      ));
  }
 
  GetFCDashboard(selectedMonth): Observable<any> {
    let url = `${environment.expenseApiUrl}GetFCDashboard/` + selectedMonth + ``;
    return this.http.get<IApiresponse<any>>(url,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() })
      .pipe(map(result => {
        result.responseInfo.forEach(element => {
          element = this.mapFCGrid(element);
        });
        return result;
      }
      ));
  }
  mapFCGrid(e): any {
    if (e != null && e != undefined) {
      return e;
    }
  }

  GetClaimantFCDetails(userId): Observable<IApiresponse<any>> {
    let url = `${environment.expenseApiUrl}GetClaimantFCDetails/` + userId;
    return this.http.get<IApiresponse<any>>(url, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  getClaimantMonthlyData(receiptId, requestType): Observable<IApiresponse<any>> {
    let url = `${environment.expenseApiUrl}GetClaimantMonthlyMileage/` + receiptId + '/' + requestType;
    return this.http.get<IApiresponse<any>>(url, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  GetClaimantFCDetailsByMonth(selectedMonth): Observable<IApiresponse<any>> {
    let url = `${environment.expenseApiUrl}GetClaimantFCDetailsByMonth/` + selectedMonth;
    return this.http.get<IApiresponse<any>>(url, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

  CalculateFCDistance(request: IApiRequest<FuelCardDetails>): Observable<IApiresponse<FuelCardDetails>> {
    let body = JSON.stringify(request);
    return this.http.post<IApiresponse<FuelCardDetails>>(`${environment.expenseApiUrl}CalculateFCDistance`,
      body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
  }

}
